import React from 'react'
import styled from 'styled-components'
import { Small, Link } from 'components/styled/typography'
import { imagePath } from 'utils/image'
import defaultHero from 'assets/default-hero-image.jpg'
import { PositionType, CompanyType } from 'types'
import {
  PositionLocation as LocationBody,
  PositionDetails,
  PhotoContainer,
  PositionTitle,
} from '../position-card'

export interface JobAdCardProps {
  jobAd: PositionType
  company: CompanyType
  jobAdEndTime?: string
}

const StyledJobAdCard = styled.div`
  all: unset;
  display: flex;
  cursor: pointer;
  overflow: none;
  background-color: ${({ theme }) => theme.color.grey07};
  border-radius: ${({ theme }) => theme.space.s8};
  flex-direction: column;
  user-select: none;

  &:hover {
    background-color: ${({ theme }) => theme.color.grey10};
    text-decoration: none !important;
  }

  &:active {
    background-color: ${({ theme }) => theme.color.grey20};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.grey05};
    color: ${({ theme }) => theme.color.grey30};
  }

  &.focus-visible {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.color.white},
      0 0 0 3px ${({ theme }) => theme.color.grey70};
  }
`

const StyledAdLink = styled(Link)`
  text-decoration: none !important;
`

const JobAdPhoto = styled(PhotoContainer)`
  height: ${({ theme }) => theme.space.s128};
`
const StyledInfoContainer = styled.div`
  padding: ${({ theme }) => theme.space.s12};
  overflow: hidden;
  height: ${({ theme }) => theme.space.s128};
`
const JobAdDetails = styled(PositionDetails)`
  height: ${({ theme }) => theme.space.s80};
`

export const JobAdCard: React.FC<JobAdCardProps> = ({
  jobAd,
  company,
  jobAdEndTime,
}) => {
  const cardPhoto = jobAd.photo ? imagePath(jobAd.photo) : defaultHero
  const { slugs = [] } = jobAd

  return (
    <StyledJobAdCard>
      <StyledAdLink
        to={`/careers/${jobAd.language}/${company.slug}/${[...slugs].pop()}`}
      >
        <JobAdPhoto $image={cardPhoto} />
        <StyledInfoContainer>
          <JobAdDetails mb="s8">
            {jobAd.title && (
              <PositionTitle fontWeight={600} mb="s0" numberOfLines={2}>
                {jobAd.title}
              </PositionTitle>
            )}
            {jobAd.location && (
              <LocationBody numberOfLines={1}>{jobAd.location}</LocationBody>
            )}
          </JobAdDetails>
          {jobAdEndTime && <Small color="grey90">{jobAdEndTime}</Small>}
        </StyledInfoContainer>
      </StyledAdLink>
    </StyledJobAdCard>
  )
}
